import { FormControlLabel, Switch, Tooltip, Typography } from '@mui/material';
import { useTooltipSettings } from '../contexts/TooltipContext';

export default function TooltipToggle() {
  const { tooltipsEnabled, toggleTooltips } = useTooltipSettings();

  return (
    <Tooltip
      title={tooltipsEnabled ? 'Disable tooltips' : 'Enable tooltips'}
      placement='bottom'
    >
      <FormControlLabel
        control={
          <Switch
            checked={tooltipsEnabled}
            onChange={toggleTooltips}
            size='small'
            color='primary'
          />
        }
        label={
          <Typography
            variant='body2'
            sx={{ fontSize: '0.75rem', color: 'text.secondary' }}
          >
            Tooltips
          </Typography>
        }
        sx={{ margin: 0 }}
      />
    </Tooltip>
  );
}
